import Vue from 'vue';
import locale from 'element-ui/lib/locale/lang/en';
import { Message, Select, Option, Tooltip, Input, Popover, Dropdown, DropdownMenu, DropdownItem } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

const components = [Message, Select, Option, Tooltip, Input, Popover, Dropdown, DropdownMenu, DropdownItem];

const Element = {
  install(vue) {
    components.forEach((component) => {
      vue.component(component.name, component);
    });
  },
};
Vue.prototype.$message = Message;
Vue.use(Element, { locale });
